module.exports = __webpack_public_path__ + "assets/img/icon-1.0b812407.png";